import api from '../utils/api';

export const getHistoryByUser = async (userId: number) => {
    try {        
        const res = await api.get(`/api/histories`, {
            params: {
                populate: '*',
                sort: 'createdAt:desc',
                filters: {
                    user: { id : { $eq: userId } }
                }
            }
          });
        
        return res.data.data;
    } catch (e) {
        console.error(e);
        throw e;
    }
}

export const addHistory = async (userId: string, projectId: string, type: string) => {
    try {
        const res = await api.post(`/api/histories`, {
            data: {
                type : type,
                user : userId,
                project : projectId
            }
        });
        
        return res;
    } catch (e) {
        console.error(e);
        throw e;
    }
}